import { FormattedMessage } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { EmailsInput } from '@/components/ui/EmailsInput';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';

const SplitNotificationsEmailsOptions = () => {
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreference = useAppSelector(getUserPreferences);

  const handleChange = (splitNotificationsEmailsOptions: string[]) => {
    updateUserPreferences({ ...userPreference, splitNotificationsEmailsOptions });
  };

  return (
    <div>
      <p className="mt-2 mb-2">
        <FormattedMessage id="userPreferences.section.SplitNotificationsEmailsOptions" />
      </p>
      <EmailsInput
        emails={userPreference.splitNotificationsEmailsOptions}
        onChange={handleChange}
        dataE2e="user-preferences-notifications-emails-for-options"
      />
    </div>
  );
};

export default SplitNotificationsEmailsOptions;
